var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"ooo_main"},[_c('div',{staticClass:"child"},[_c('div',{staticClass:"text"},[_c('h1',[_vm._v("404")])]),_c('div',{staticClass:"msg"},[_c('span',[_vm._v("Employee not found.")]),_c('span',[_vm._v("Employee on vacation.")]),_c('span',[_vm._v("Will revert back soon.")])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }